import { UNAUTHORIZED_STATUS_CODE } from "./constants";
import log from 'loglevel';
import { messagingChannelActions } from "../../src/slices/messagingChannelSlice";
import { userSessionActions } from "../../src/slices/userSessionSlice";

const authInterceptor = ({dispatch}) => (next) => async(action) => {
    try {
      if (action.error && action.error.message && action.error.message.includes("Unauthorized")
      ) {
        log.info("unauthorized");
        dispatch(userSessionActions.openDialog({
          open :true,
          msgType : "Unauthorized"
      }));
      }
      else if (messagingChannelActions.connectionError.match(action)) {
        log.info("signalr error : messagingChannelActions.connectionError %o", action.payload);
        if (action.payload && (action.payload.includes(UNAUTHORIZED_STATUS_CODE))
        ) {
            dispatch(userSessionActions.openDialog({
                open :true,
                msgType : "Unauthorized"
            }));
        }
      }
    } catch{
      log.error("ERROR in authInterceptor");
    }
  
    next(action);
  };
  
export default authInterceptor;